import React, { useState } from 'react';
import Iconify from '../../../../Iconify';
import Text from '../../../../Text/Text';
import styles from './welcome.module.css';
import { Amount } from '../amount';
import { PAYMENT_METHOD } from '../../constants';
import iconMoney from '../../assets/icono-monto-a-depositar.png';
import visaMaster from '../../assets/visa-master.png';
import speiLogo from '../../assets/spei.png';
import speiExtraBonus from '../../assets/spei-extra-bonus.png';
import iconoTienda from '../../assets/icono-pago-en-tienda.png';
import otherCardLogo from '../../assets/icono-otras-tarjetas.png';
import { useSoundClick } from '../../hooks/use-sound-click';
import usePaymentStore from '../../store/use-payment-store';
import { waitVerificationName } from '../modals/modal-verification-name';

// Mapeo de iconos que devuelve el API a assets locales
const ICON_BY_FILENAME = {
  'visa-mastercard.png': visaMaster,
  'visa-master.png': visaMaster,
  'spei.png': speiLogo,
  'stores.png': iconoTienda,
  'other-cards.png': otherCardLogo,
};

const getMethodIcon = (iconFilename) => iconFilename && (ICON_BY_FILENAME[iconFilename] || ICON_BY_FILENAME[iconFilename?.replace(/^.*\//, '')]);

const isSameMethod = (a, b) => a?.type === b?.type && a?.gateway === b?.gateway;

export const Welcome = ({ setSelectedMethod, userPaymentMethods = [] }) => {
  const play = useSoundClick();
  const { amount } = usePaymentStore();

  const [localSelectedMethod, setLocalSelectedMethod] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleContinue = async () => {
    const isVerified = await waitVerificationName({
      title: 'Verificación de nombre',
    });

    if (!isVerified) {
      alert('Por favor, verifica tu cuenta para poder depositar.');
      return;
    }

    // Validar que tenga monto y método seleccionado
    if (!amount || amount < 50) {
      setErrorMessage('Debes ingresar el monto');
      return;
    }
    if (!localSelectedMethod) {
      setErrorMessage('Debes seleccionar el metodo de pago');
      return;
    }
    setErrorMessage(null);
    setSelectedMethod(localSelectedMethod);
  };

  const handleMethodClick = async (method) => {
    play();
    setLocalSelectedMethod(method);
    if (errorMessage) setErrorMessage(null);
  };

  const methods = Array.isArray(userPaymentMethods) ? userPaymentMethods : [];

  return (
    <div>
      <img src={iconMoney} alt="Icono de monto a depositar" className={styles.iconMoney} />
      <Text center size={18} weight={600} mb={15}>
        Monto a <span className={styles.textPrimary}>depositar</span>
      </Text>

      <Amount />

      <Text center size={14} weight={600} mb={15}>
        Selecciona el método de pago
      </Text>

      <div className={styles.paymentMethodsGrid}>
        {methods.map((method) => {
          const methodKey = `${method.type}_${method.gateway}`;
          const isSelected = isSameMethod(localSelectedMethod, method);
          const methodIcon = getMethodIcon(method.icon);
          const methodLabel = method.label || method.type;
          const isSpei = method.type === 'spei';
          const bonus = method.bonus && typeof method.bonus === 'object';

          if (isSpei && bonus) {
            return (
              <button
                key={methodKey}
                type="button"
                className={`${styles.speiCard} ${isSelected ? styles.speiSelected : ''}`}
                onClick={() => handleMethodClick(method)}
              >
                <div className={styles.speiCardContent}>
                  {bonus && (
                    <div className={styles.speiBonusBadge}>
                      <img
                        src={speiExtraBonus}
                        alt="Bonus"
                        className={styles.speiBonusImage}
                      />
                    </div>
                  )}
                  <div className={styles.speiMainContent}>
                    <div className={styles.speiLeftContent}>
                      <div className={styles.speiTitleRow}>
                        <img
                          src={methodIcon || speiLogo}
                          alt="SPEI"
                          className={styles.speiIcon}
                        />
                      </div>
                      <span className={styles.speiSubtitle}>{methodLabel}</span>
                      {(bonus && method.bonus.conditions) && (
                        <p
                          className={styles.speiPromo}
                          dangerouslySetInnerHTML={{ __html: method.bonus.conditions }}
                        />
                      )}
                    </div>
                  </div>
                  <div className={styles.speiRadioIndicator}>
                    <div className={`${styles.radioCircle} ${isSelected ? styles.radioSelected : ''}`} />
                  </div>
                </div>
              </button>
            );
          }

          return (
            <button
              key={methodKey}
              type="button"
              className={`${styles.paymentMethodCard} ${isSelected ? styles.selected : ''}`}
              onClick={() => handleMethodClick(method)}
            >
              <div className={styles.cardContent}>
                <div className={styles.iconContainer}>
                  {methodIcon ? (
                    <img src={methodIcon} alt={methodLabel} className={styles.methodIcon} />
                  ) : (
                    <div className={styles.iconPlaceholder} />
                  )}
                </div>
                <div className={styles.labelContainer}>
                  <span className={styles.methodLabel}>{methodLabel}</span>
                </div>
              </div>
              <div className={styles.radioIndicator}>
                <div className={`${styles.radioCircle} ${isSelected ? styles.radioSelected : ''}`} />
              </div>
            </button>
          );
        })}
      </div>

      <div className={styles.continueButtonContainer}>
        <div className={styles.buttonWrapper}>
          <button
            className="payment-button"
            onClick={handleContinue}
            // disabled={!localSelectedMethod || !amount || amount < 50}
            style={{ marginBottom: '0.3em', pointerEvents: 'auto !important' }}
          >
            Continuar
            <Iconify icon="mdi:arrow-right" style={{ fontSize: 20 }} />
          </button>
          {errorMessage && (
            <div className={styles.errorMessage}>
              {errorMessage}
            </div>
          )}
        </div>
        <div className={styles.divider} ></div>
        <button
          className={styles.transferButton}
          onClick={() => {
            play();
            setSelectedMethod(PAYMENT_METHOD.TRANSFER);
          }}
        >
          Transferir saldo a otro usuario
          <Iconify icon="mdi:arrow-right" style={{ fontSize: 20, color: '#ffffff' }} />
        </button>
      </div>
    </div>
  );
};